import { DeliveryNoteStatusApiService } from '@api/api.service';
import { ReceiptStatusService } from '../base';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteStatusService extends ReceiptStatusService {
  constructor(api: DeliveryNoteStatusApiService) {
    super(api);
  }
}
